import React, { useEffect, useRef, useState } from 'react';
import './input.style.scss';
import { __InputProps, __InputRef } from './input.interface';
import { Language, ReduxState, TextDirection } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { extractTitle } from 'scripts/string';
export interface SLPInputRef extends __InputRef {}

const SLPInput: React.ForwardRefRenderFunction<__InputRef, ConnectedProps<typeof connector> & __InputProps> = (
    props: ConnectedProps<typeof connector> & __InputProps,
    ref,
) => {
    const lang = props.lang.utilities;
    const inputRef = useRef<HTMLInputElement>(null);
    const [error, setError] = useState<string>();
    const [active, setActive] = useState<boolean>(false);
    const immediateValue = useRef(props.defaultValue ? props.defaultValue : '');
    const [value, setValue] = useState<string>(immediateValue.current);
    const labelRef = useRef<HTMLLabelElement>(null);

    React.useImperativeHandle(ref, () => ({
        getValue: () => (inputRef.current ? inputRef.current.value : ''),
        getValidation: () => Validation(),
        setError: (text) => setError(text),
        setUnError: () => setError(undefined),
    }));

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    function onFocusHandler() {
        setActive(true);
    }
    function onblurHandler() {
        setActive(false);
    }
    function onClickHandler() {
        inputRef.current?.focus();
    }
    function onChangeHandler(e: any) {
        setError(undefined);
        immediateValue.current = e.target.value;
        setValue(immediateValue.current);
        if (props.onChange) props.onChange(immediateValue.current);
    }
    function onKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.charCode === 13 && props.onEnter) {
            e.currentTarget.blur();
            e.preventDefault();
            props.onEnter(immediateValue.current);
        }
    }
    function Validation() {
        let validate = true;
        if (immediateValue.current)
            if (
                (props.length && immediateValue.current.length !== props.length) ||
                (props.maxLength && immediateValue.current.length > props.maxLength) ||
                (props.minLength && immediateValue.current.length < props.minLength)
            )
                validate = false;
        return validate;
    }

    return (
        <div
            onClick={onClickHandler}
            className={`ucheck-SLP-input ${value && value.length ? 'filled' : ''} ${active ? 'active' : ''} ${
                error ? 'error' : ''
            }  ${props.dir === TextDirection.rtl ? 'rtl-text' : ''}`}
        >
            <span className="d-flex">
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </span>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <div className={`input-box ${props.endIcon ? 'has-end-icon' : ''}`}>
                <input
                    ref={inputRef}
                    value={value}
                    onFocus={onFocusHandler}
                    onBlur={onblurHandler}
                    onChange={onChangeHandler}
                    onKeyPress={(e) => onKeyPress(e)}
                    style={{ color: props.color }}
                    required={props.required}
                    enterKeyHint="next"
                    type={props.type}
                    placeholder={
                        props.placeholder
                            ? props.placeholder
                            : props.type === 'email'
                            ? lang.SLPEmailPH
                            : props.formLang === Language.en
                            ? lang.SLPInputPHEn
                            : lang.SLPInputPH
                    }
                />
                {props.endIcon && (
                    <i className="material-icons" style={{ color: props.endIcon.color }}>
                        {props.endIcon.icon}
                    </i>
                )}
            </div>
            {error && <p className="input-error">{error}</p>}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPInput));
